import { computed } from 'vue'
import {
  DEFAULT_MAPS_BASEMAP_URL,
  createBasemapStyle,
  productCoordinates
} from '../lib/basemapStyle'

export const DEFAULT_MARKER_COLOR = '#3c8bd9'

export function schemeMarkerColor (host?: HTMLElement | null): string {
  if (typeof document === 'undefined') {
    return DEFAULT_MARKER_COLOR
  }
  const probe = document.createElement('div')
  probe.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;pointer-events:none;background-color:var(--johku-color-primary, var(--johku-color-button-primary-background, var(--johku-color-titlebar-background, ' + DEFAULT_MARKER_COLOR + ')))'
  const parent = host && host.isConnected ? host : document.body
  parent.appendChild(probe)
  const resolved = getComputedStyle(probe).backgroundColor
  probe.remove()
  if (!resolved || resolved === 'rgba(0, 0, 0, 0)' || resolved === 'transparent') {
    return DEFAULT_MARKER_COLOR
  }
  return resolved
}

export function useBasemap () {
  const mapsBasemapUrl = computed(() => {
    try {
      const config = useRuntimeConfig()
      const fromConfig = (config.public as { mapsBasemapUrl?: string }).mapsBasemapUrl
      return fromConfig || DEFAULT_MAPS_BASEMAP_URL
    } catch {
      return DEFAULT_MAPS_BASEMAP_URL
    }
  })

  const basemapStyle = (lang?: string | null) => {
    return createBasemapStyle({
      tileUrl: mapsBasemapUrl.value,
      lang
    })
  }

  return {
    mapsBasemapUrl,
    basemapStyle,
    productCoordinates,
    schemeMarkerColor
  }
}
